import { useState } from "react";
import "./SinglePhoto.css";

const SinglePhoto = (props) => {
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(props.index);

  const openModal = () => {
    setCurrentIndex(props.index);
    setShow(true);
    document.body.classList.add("active-modl");
  };

  const closeModal = () => {
    setShow(false);
    document.body.classList.remove("active-modl");
  };

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % props.photos.length);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + props.photos.length) % props.photos.length);
  };

  return (
    <>
      {show && (
        <div className="modal">
          <div onClick={closeModal} className="overlay"></div>
          <div className="modal-content">
            <button className="close-modal" onClick={closeModal}>
              X
            </button>
            <button className="modal-nav modal-prev" onClick={showPrev}>
              {"<"}
            </button>
            <img
              className="modal-picture"
              src={props.photos[currentIndex]}
              alt="LandScapeimage"
            />
            <button className="modal-nav modal-next" onClick={showNext}>
              {">"}
            </button>
          </div>
        </div>
      )}
      <div className="singlePhoto-div">
        <img
          alt="LandScapingPicture"
          className="photo"
          src={props.photo}
          onClick={openModal}
        />
      </div>
    </>
  );
};

export default SinglePhoto;
